'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'space-station-moon';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e033';
var svgPathData = ['M48 256c0 12.8 1.1 25.2 3.3 37.4 .5 .2 1 .4 1.5 .5 34.9 12.6 94.8 34.1 203.2 34.1s168.3-21.5 203.2-34.1c.5-.2 1-.4 1.5-.5 2.2-12.1 3.3-24.6 3.3-37.4 0-114.9-93.1-208-208-208S48 141.1 48 256zm22.7 94.7C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3C402.1 362.7 343 376 256 376S109.9 362.7 70.7 350.7zM304 176a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z', 'M256 48c-114.9 0-208 93.1-208 208 0 12.8 1.1 25.2 3.3 37.4 .5 .2 1 .4 1.5 .5 34.9 12.6 94.8 34.1 203.2 34.1s168.3-21.5 203.2-34.1l0 0c.5-.2 1-.4 1.5-.5 2.2-12.1 3.3-24.6 3.3-37.4 0-114.9-93.1-208-208-208zM441.3 350.7C402.1 362.7 343 376 256 376S109.9 362.7 70.7 350.7C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256a256 256 0 1 1 -512 0 256 256 0 1 1 512 0zM208 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;